export default __webpack_public_path__ + "static/media/bears-drool.886a0d62.jpeg";